import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setRefreshTimestamps, useRefreshTimestamps } from "../redux/slices/authSlice";

const useAutoRefresh = (id) => {
  const dispatch = useDispatch();
  const globalRefreshTimes = useRefreshTimestamps()

  const [refreshTime, setRefreshTime] = useState(() => {
    return globalRefreshTimes?.[id] || new Date().toLocaleString();
  });

  useEffect(() => {
    const time = globalRefreshTimes?.[id] || new Date().toLocaleString();
    setRefreshTime(time);
  }, [id, globalRefreshTimes]);

  const updateRefreshTime = () => {
    const now = new Date().toLocaleString();
    const updatedTimestamps = {
      ...globalRefreshTimes,
      [id]: now,
    };
    dispatch(setRefreshTimestamps(updatedTimestamps));
    setRefreshTime(now);
  };

  return { refreshTime, updateRefreshTime };
};

export default useAutoRefresh;
